import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";

import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "myresources-config",
    templateUrl: "./myresources-config.view.html",
    providers: []
})
export class MyresourcesConfigView implements OnInit {
    baseUrl = "";
    expansionStyle = "";
    headerConfig: any = {};
    buttonConfig: any = {};

    constructor(public sharedService: SharedService, private activatedRoute: ActivatedRoute) {
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = sharedService.sessionUrl;
            if (!this.sharedService.sessionLayoutConfig[this.baseUrl].hasOwnProperty("header")) {
                this.headerConfig = {
                                        label: "Session Resources",
                                        label_color: "#FBFBFB",
                                        icon_color: "#FFFFFF",
                                        background: "#0d2958"
                                    };
            } else {
                this.headerConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].header;
            }
    
            if (!this.sharedService.sessionLayoutConfig[this.baseUrl].hasOwnProperty("button")) {
                this.buttonConfig = {
                                        primary: {
                                            background: "#0d2958",
                                            color: "#FBFBFB"
                                        },
                                        secondary: {
                                            background: "#FBFBFB",
                                            color: "#0d2958"
                                        }
                                    };
            } else {
                this.buttonConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].button;
            }
            
            this.expansionStyle = this.sharedService.expansionStyle;
        }
    }

    ngOnInit() {}
}
